module.exports = __webpack_public_path__ + "static/img/heelow.babcf27.png";


//////////////////
// WEBPACK FOOTER
// ./img/heelow.png
// module id = ssu3
// module chunks = 1